import { Contract } from "@/services/backend/rlt/contracts/types/contract";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { Comments } from "@/services/backend/comments/components/comments";

export function ContractComments({ contract }: { contract: Contract }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Interne Kommentare")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können interne Kommentare zum Vertrag erstellt und nachgeschlagen werden.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Comments ownerId={contract.id} ownerType="contract.Contract" />
      </CardContent>
    </Card>
  );
}
